import moment from "moment";

export const filterAddonServicesByDates = ({ addonservices, fromdate }) => {
  if (!fromdate) return addonservices;

  const checkInDate = moment(fromdate, "DD-MM-YYYY");

  return addonservices.filter((service) => {
    const start = moment(service.dateApplied.startDate);
    const end = moment(service.dateApplied.endDate);
    return checkInDate.isBetween(start, end, null, "[]");
  });
};
